import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import fallbackBooks from './booksData';
import { getBook } from '../../services/contentApi';
import './BooksPage.css';

export default function BookDetailPage() {
  const { bookId } = useParams();
  const navigate = useNavigate();
  const [book, setBook] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function loadBook() {
      setLoading(true);
      try {
        const data = await getBook(bookId);
        if (!cancelled && data) {
          setBook(data);
          return;
        }
      } catch {
        // Fallback to local data
      }

      if (!cancelled) {
        const found = fallbackBooks.find((b) => b.id === bookId);
        setBook(found || null);
      }
    }

    loadBook().finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [bookId]);

  if (loading) {
    return (
      <main className="bk-page">
        <div className="bk-state">加载中...</div>
      </main>
    );
  }

  if (!book) {
    return (
      <main className="bk-page">
        <div className="bk-state">未找到该书籍</div>
      </main>
    );
  }

  const highlightsHtml = DOMPurify.sanitize(marked(book.highlights));

  return (
    <main className="bk-page">
      <button className="bk-back" onClick={() => navigate('/books')}>
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
          <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        返回书籍库
      </button>

      <header className="bk-detail-header">
        <div className="bk-detail-cover-wrap">
          <img className="bk-detail-cover" src={book.cover} alt={book.title} loading="lazy" />
        </div>
        <div className="bk-detail-info">
          <div className="bk-tags">
            <span className={`bk-diff ${book.difficulty === '入门' ? 'beginner' : 'advanced'}`}>{book.difficulty}</span>
          </div>
          <h1 className="bk-detail-title">{book.title}</h1>
          <p className="bk-detail-author">{book.author}</p>
          <p className="bk-detail-summary">{book.summary}</p>
        </div>
      </header>

      <section className="bk-highlights">
        <div className="bk-highlights-label">核心精华</div>
        <div
          className="bk-highlights-content markdown-content"
          dangerouslySetInnerHTML={{ __html: highlightsHtml }}
        />
      </section>

      <button className="bk-back bk-back-bottom" onClick={() => navigate('/books')}>
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
          <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        返回书籍库
      </button>
    </main>
  );
}
